module.exports = __webpack_public_path__ + "static/media/shopping6.dd745e36.png";